import React from "react";
import { useState } from "react";
import { Fragment, useEffect } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import days from "../../AgeData/day.json";

import years from "../../AgeData/year.json";
import moment from "moment";

import { useTranslation } from "react-i18next";

import { translateKey } from '../../utility';

const months = 
  [
    { "id": 1, "month": translateKey("january") },
    { "id": 2, "month": translateKey("february") },
    { "id": 3, "month": translateKey("march") },
    { "id": 4, "month": translateKey("april") },
    { "id": 5, "month": translateKey("may") },
    { "id": 6, "month": translateKey("june") },
    { "id": 7, "month": translateKey("july") },
    { "id": 8, "month": translateKey("august") },
    { "id": 9, "month": translateKey("september") },
    { "id": 10, "month": translateKey("october") },
    { "id": 11, "month": translateKey("november") },
    { "id": 12, "month": translateKey("december") }
  ]

function PetAge({ petInfo, setPetInfo, setIsComplete, petType }) {
  const [bornYear, setBornYear] = useState(0);
  const [bornMonth, setBornMonth] = useState(0);
  const [bornDay, setBornDay] = useState(0);
  const [activator, setActivator] = useState(false);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  
  const { t } = useTranslation();

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        birth: { ...petInfo.birth, day: bornDay },
      });
    }
  }, [bornDay]);

  if (petInfo.birth.year) {
    setIsComplete(true);
  }

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        birth: { ...petInfo.birth, month: bornMonth },
      });
    }
  }, [bornMonth]);

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        birth: { ...petInfo.birth, year: bornYear },
      });
    }
  }, [bornYear]);


  const updatePetInfo = () => {
    setActivator(true);
    if (activator) {
      let date = moment(
        `${bornMonth.id ? bornMonth.id : "01"}-${
          bornDay ? bornDay : "01"
        }-${bornYear}`.replace(/-/g, "/")
      );
      setPetInfo({ ...petInfo, birthDate: date });
    }
  };

  useEffect(() => {
    updatePetInfo();
  }, [petInfo.birth]);

  //lg:h-5/10
  return (
    <div className="h-9/10 w-11/12 max-w-lg flex flex-col justify-center">
      <div className="mb-2 font-medium font-poppins text-lg text-yellow-600 pt-12">
          {petType == 'dog' ? t("petBirthDate") : t("catPetBirthDate")}
      </div>
      <div className="m-6">
        <Listbox value={bornYear} onChange={setBornYear}>
          {({ open }) => (
            <>
              <Listbox.Label className="block font-medium font-poppins text-lg text-yellow-600 text-left">
                {t("year")}
              </Listbox.Label>
              <div className="mt-1  relative">
                <Listbox.Button className="bg-white w-full  relative border border-yellow-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-lime-500 focus:border-lime-500 sm:text-sm">
                  <span className="block truncate text-yellow-800">
                    {petInfo.birth.year
                      ? `${petInfo.birth.year}`
                      : t("chooseYear")}
                  </span>
                  <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>

                <Transition
                  show={open}
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                    {years.map((item, key) => (
                      <Listbox.Option
                        key={key}
                        className={({ active }) =>
                          classNames(
                            active
                              ? "text-white bg-lime-600"
                              : "text-yellow-800",
                            "cursor-default select-none relative py-2 pl-3 pr-9"
                          )
                        }
                        value={item.year}
                      >
                        {({ bornYear, active }) => (
                          <>
                            <span
                              className={classNames(
                                bornYear ? "font-semibold  " : "font-normal",
                                "block truncate text-left "
                              )}
                            >
                              {item.year}
                            </span>

                            {bornYear ? (
                              <span
                                className={classNames(
                                  active ? "text-white" : "text-lime-600",
                                  "absolute inset-y-0 right-0 flex items-center pr-4"
                                )}
                              >
                                <CheckIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      </div>
      <div className="m-6">
        <Listbox value={bornMonth} onChange={setBornMonth}>
          {({ open }) => (
            <>
              <Listbox.Label className="block font-medium font-poppins text-lg text-yellow-600 text-left">
                {t("month")}
                <p className="text-xs leading-5 text-yellow-600">
                  {t("unknownMessage")}
                </p>
              </Listbox.Label>

              <div className="mt-1  relative">
                <Listbox.Button className="bg-white w-full  relative border border-yellow-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-lime-500 focus:border-lime-500 sm:text-sm">
                  <span className="block truncate text-yellow-800">
                    {petInfo.birth.month
                      ? `${petInfo.birth.month.month}`
                      : t("chooseMonth")}
                  </span>
                  <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>

                <Transition
                  show={open}
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                    {months.map((item, key) => (
                      <Listbox.Option
                        key={key}
                        className={({ active }) =>
                          classNames(
                            active
                              ? "text-white bg-lime-600"
                              : "text-yellow-800",
                            "cursor-default select-none relative py-2 pl-3 pr-9"
                          )
                        }
                        value={item}
                      >
                        {({ bornMonth, active }) => (
                          <>
                            <span
                              className={classNames(
                                bornMonth ? "font-semibold  " : "font-normal",
                                "block truncate text-left "
                              )}
                            >
                              {item.month}
                            </span>

                            {bornMonth ? (
                              <span
                                className={classNames(
                                  active ? "text-white" : "text-lime-600",
                                  "absolute inset-y-0 right-0 flex items-center pr-4"
                                )}
                              >
                                <CheckIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      </div>
      <div className="m-6">
        <Listbox value={bornDay} onChange={setBornDay}>
          {({ open }) => (
            <>
              <Listbox.Label className="block font-medium font-poppins text-lg text-yellow-600 text-left">
                {t("day")}
                <p className="text-xs leading-5 text-yellow-600">
                  {t("unknownMessage")}
                </p>
              </Listbox.Label>
              <div className="mt-1  relative">
                <Listbox.Button className="bg-white w-full  relative border border-yellow-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-lime-500 focus:border-lime-500 sm:text-sm">
                  <span className="block truncate text-yellow-800">
                    {petInfo.birth.day
                      ? `${petInfo.birth.day}`
                      : t("chooseDay")}
                  </span>
                  <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>

                <Transition
                  show={open}
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                    {days.map((item, key) => (
                      <Listbox.Option
                        key={key}
                        className={({ active }) =>
                          classNames(
                            active
                              ? "text-white bg-lime-600"
                              : "text-yellow-800",
                            "cursor-default select-none relative py-2 pl-3 pr-9"
                          )
                        }
                        value={item.day}
                      >
                        {({ bornDay, active }) => (
                          <>
                            <span
                              className={classNames(
                                bornDay ? "font-semibold  " : "font-normal",
                                "block truncate text-left "
                              )}
                            >
                              {item.day}
                            </span>

                            {bornDay ? (
                              <span
                                className={classNames(
                                  active ? "text-white" : "text-lime-600",
                                  "absolute inset-y-0 right-0 flex items-center pr-4"
                                )}
                              >
                                <CheckIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      </div>
    </div>
  );
}

export default PetAge;
